// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","442":"f651cd236536b0861ca655e6586c162b9e32d15e","821":"component---src-pages-portfolio-js"}[chunkId] + "-" + {"125":"1fc5f60d1a09b5e92a1d","293":"aaee0b9648b0e31354b2","442":"9bb8a9506c22fc46bc0a","821":"855b0b1888124b111ffc"}[chunkId] + ".js";
};